export class Entities {
    entities = [];
    lives_count = 0;
    videos_count = 0;
}